import React from 'react';
import { useAppSelector, configSelectors, } from '@pomofocus/shared-client';
import { IconSets } from '../../common/IconSets';
import { SectionWrapper, FormBlock, FormHeader, FormHeaderText, FlexWrapper, Switch, InfoTipComponent, } from './common';
export const TaskConfig = ({ onClickAutoCheckTasks, onClickAutoSwitchTasks, handleSwitchAutoCheckTasks, handleSwitchAutoSwitchTasks, }) => {
    const configObj = useAppSelector(configSelectors.selectConfigObj);
    return (React.createElement(SectionWrapper, { subHeader: "Task", SubHeaderIcon: React.createElement(IconSets, { name: "CheckSquare" }) },
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null,
                        "Auto Check Tasks",
                        ' ',
                        React.createElement(InfoTipComponent, { onClick: onClickAutoCheckTasks }))),
                React.createElement(Switch, { enabled: configObj.autoCheckTasks, onClick: handleSwitchAutoCheckTasks }))),
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null,
                        "Check to Bottom",
                        ' ',
                        React.createElement(InfoTipComponent, { onClick: onClickAutoSwitchTasks }))),
                React.createElement(Switch, { enabled: configObj.autoSwitchTasks, onClick: handleSwitchAutoSwitchTasks })))));
};
